module.exports = __webpack_public_path__ + "images/windows_device_icon.svg";